import React, { useEffect, useRef, useState } from "react";
import "../../../../_metronic/css/main.css";
import { Col, Row, Card, Button } from "react-bootstrap";
import { QRCode } from "react-qrcode-logo";
import html2canvas from "html2canvas";
import { useNavigate, useParams } from "react-router-dom";
import PromoCode from "../../../../core/api/api.promoCode";
import { useReactToPrint } from "react-to-print";
import _ from "lodash";
export const PrintPromoCode = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const printRef = useRef(null);

  // const printCanvas = () => {
  //   if (printRef.current) {
  //     setloading(true);
  //     html2canvas(printRef.current, { scale: 1 }).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");

  //       const iframe = document.createElement("iframe");

  //       document.body.appendChild(iframe);

  //       const iframeDoc = iframe.contentWindow.document;
  //       iframeDoc.open();
  //       iframeDoc.write("<html><head><title>Print</title></head><body>");

  //       iframeDoc.write(`
  //       <img src="${imgData}" style="width:100%;height:auto;"/>
  //     `);

  //       iframeDoc.write("</body></html>");
  //       iframeDoc.close();
  //       iframe.onload = function () {
  //         iframe.contentWindow.print();
  //         // console.log("mamad")
  //         document.body.removeChild(iframe);
  //         setloading(false);
  //       };
  //     });
  //   }
  // };

  // const reactToPrintFn = useReactToPrint({
  //   content: () => printRef?.current,
  // });

  const handlePrint = useReactToPrint({
    // documentTitle: "Print This Document",
    // onBeforePrint: () => console.log('mamad'),
    onAfterPrint: () => setloading(false),
    // removeAfterPrint: true,
  });

  const print = () => {
    if (printRef?.current) {
      setloading(true);
      try {
        handlePrint(null, () => printRef.current);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const data = await PromoCode.getPromoCode({ id });
        setData(data);
        // printCanvas();
        print();
      } catch (error) {
        console.log("error :>>", error);
      }
    })();
  }, []);

  const GoBack = () => {
    navigate(-1);
  };

  return (
    <>
      {loading && (
        <div className="loader-container">
          <div className="text-center">
            <div>در حال آماده سازی برای چاپ</div>
            <div className="s-loader mx-auto mt-3"></div>
          </div>
        </div>
      )}

      {data && (
        <>
          <div className="d-flex py-3 align-items-center justify-content-center">
            <Button
              variant="warning"
              className="px-5 mx-2"
              // onClick={printCanvas}
              onClick={print}
            >
              چاپ
            </Button>
            <Button variant="secondary" onClick={GoBack}>
              بازگشت به صفحه قبل
            </Button>
          </div>
          <div
            className="bg-white rounded-4 mx-auto"
            style={{ padding: "20px", width: "210mm" }}
          >
            {/* محتوای که می‌خواهید از آن اسکرین‌شات بگیرید */}
            <div ref={printRef}>
              <div className="rtl line-height-1 react-to-print">
                <div className="d-flex justify-content-center">
                  <img
                    src="/media/logos/logo-s1.png"
                    alt=""
                    className="mx-auto pb-4"
                    style={{ width: "150px" }}
                  />
                </div>
                <div className="d-flex justify-content-center flex-wrap">
                  {data?.amusementServices?.map((item, index) => (
                    <Card
                      key={index}
                      className="rounded-4 text-center border bg-light mr-2 mb-2"
                      style={{ width: "120px" }}
                    >
                      <Card.Img
                        className="rounded-4 rounded-bottom-0"
                        variant="top"
                        src={`http://localhost:9005${item?.imageUrl}`}
                        style={{ height: "91px" }}
                      />
                      <Card.Body className="px-1 py-1">
                        <Card.Text className="font-size-sm">
                          {item?.name}
                        </Card.Text>
                      </Card.Body>
                      <Card.Footer className="fw-bold text-danger border-top-0 bg-transparent font-size-lg px-1 py-1">
                        تخفیف ویژه
                      </Card.Footer>
                    </Card>
                  ))}
                </div>
                <Row className="mt-3">
                  <Col className="text-center my-auto position-relative">
                    <div className="pt-5">
                      <QRCode
                        size={140}
                        value={
                          "https://www.tafrihan.com/?prc=" + data?.promoCode
                        }
                        logoOpacity={100}
                        logoWidth={90}
                        logoHeight={60}
                        style={{
                          height: "auto",
                          maxWidth: "100%",
                          width: "100%",
                        }}
                      ></QRCode>
                    </div>

                    <div className="text-center" style={{ fontSize: "15px" }}>
                      <div className="pb-1">1.بارکد را اسکن نمایید.</div>
                      <div className="mx-auto" style={{ width: "180px" }}>
                        2. با شماره {data?.userPhoneNumber} وارد پنل کاربری خود
                        شوید.
                      </div>
                      <div className="pb-1">3.سبد خرید را ایجاد نمایید.</div>
                      <div>4.کد تخفیف را وارد نمایید.</div>
                    </div>
                    <div className="px-5 py-0 rounded-3 d-inline-block fw-bold latin-text mt-3 mb-5">
                      {data?.promoCode}
                    </div>
                    <div className="mx-auto" style={{ width: "150px" }}>
                      توجه فرمایید جهت استفاده از کد تخفیف فوق حتما باید در سایت
                      با شماره {data?.userPhoneNumber} وارد شده باشید.{" "}
                    </div>
                    <div className="fw-bold text-black mt-5">
                      <div className="pb-1">www.tahrihan.com</div>
                      <div className="pb-1">شماره تماس :07644100000 </div>
                      <div>شماره پشتیبانی : 09199781891</div>
                    </div>
                    <div className="arrow-svg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        shape-rendering="geometricPrecision"
                        text-rendering="geometricPrecision"
                        image-rendering="optimizeQuality"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        viewBox="0 0 512 190.285"
                      >
                        <path d="M512 62.269c-32.208 3.503-65.126 11.155-82.935 11.576-5.87.14-13.175-.651-5.825-3.929 17.743-7.915 39.85-13.415 61.461-14.291-4.787-1.077-9.548-2.473-15.993-4.683-42.916-14.717-91.165-23.694-138.308-23.756-39.015-.053-79.822 5.737-115.535 22.126 13.263 12.299 25.007 25.723 35.154 40.787 21.629 32.107 31.567 79.665-13.75 96.773-37.675 14.221-72.262-18.318-76.731-54.787-3.222-26.29 6.915-45.475 19.352-63.408 5.258-7.581 11.717-14.262 19.168-20.104C105.119-16.905 17.276 26.293 0 117.511 4.91 5.165 125.544-21.164 205.932 42.942c70.469-46.003 210.713-30.084 282.411 7.501-9.463-9.291-17.535-22.446-22.866-35.006-.79-1.859-4.569-8.993-4.29-12.878.102-1.443.766-2.442 2.348-2.553.903-.063 1.863.407 2.868 1.35 2.92 2.749 9.199 13.053 15.44 23.057C491.104 39.255 499.115 50.13 512 62.269zm-304.367-6.573c13.918 12.907 26.764 28.048 37.028 43.982 16.542 25.678 22.453 56.275-1.472 72.95-14.806 10.319-30.931 9.682-44.76 1.389-49.808-29.871-25.747-96.994 9.204-118.321z" />
                      </svg>
                    </div>
                  </Col>
                  <Col xs="6" className="text-center position-relative">
                    <img
                      src="/media/bg/promoCode.jpg"
                      alt="promo code"
                      width={320}
                    />
                    <div className="code-on-pic">{data?.promoCode}</div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
